import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderByPublished',
})
export class OrderByPublishedPipe implements PipeTransform {
  transform(faqs: any[]): any[] {
    return faqs.slice().sort((a, b) => b.is_published - a.is_published);
  }
}
